import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { BeanConfiguracao } from 'src/bean/BeanConfiguracao';
import { BeanUsuario } from 'src/bean/BeanUsuario';
import { AESEncryptDecryptService } from '../../AESEncryptDecryptService';
import { Autenticacao } from '../../autenticacao.service';
import { ConfiguracaoService } from '../configuracao/configuracao.service';
import { CadastroUsuarioService } from './../cadastro-usuario/cadastro-usuario.service';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit {

  public versionApplication : string;

  @Output() public exibirPainel: EventEmitter<string> = new EventEmitter<string>()

  public formLogin: FormGroup = new FormGroup({
    'usuario': new FormControl(null, [Validators.required]),
    'senha': new FormControl(null, [Validators.required])
  })

  linkDNS : string = "";
  hide = true;
  loading : boolean = false;

  public login:boolean = true;
  public senha:boolean = false;
  public aguarde:boolean = false


  constructor(
      private toastr: ToastrService,
      private auth: Autenticacao,
      private router: Router,
      private activatedRoute: ActivatedRoute,
      private configuracaoService : ConfiguracaoService,
      private cadastroUsuarioService: CadastroUsuarioService,
      private _AESEncryptDecryptService: AESEncryptDecryptService

     ) { }

  ngOnInit(): void {


    /*
    Acesso interno a pluris:
    172.20.8.91:8004 = easyquality.dm-pluris.com.br
    72.20.8.91:8005 = easyqualitybackend.dm-pluris.com.br

    Acesso externo a pluris:
    168.138.231.89:8004 = easyquality.plurismidia.com.br
    168.138.231.89:8005 = easyqualitybackend.plurismidia.com.br*/

    if(window.location.href.includes('172.20.8.91:8004')){ //BLOQUEAR ACESSO VIA IP INTERNO
      this.linkDNS = "http://easyquality.dm-pluris.plurismidia.com.br:8004/#/"
      return

    }else if(window.location.href.includes('168.138.231.89')){//BLOQUEAR ACESSO VIA IP EXTERNO
      this.linkDNS = "https://easyquality.plurismidia.com.br/#/"
      return
    }

    this.versionApplication = '1.0.0'
    localStorage.clear();

    this.validaAcessoAuthenticator();
  }

  loginAuthenticator(token: string, usuaDsRe: string){

    localStorage.clear();

    this.auth.loginAuthenticator(token, usuaDsRe).subscribe({
      next: (retornoLongin:any) => {
        if(retornoLongin.usuaIdCdUsuario != null && retornoLongin.usuaIdCdUsuario > 0){

          localStorage.setItem("access_token", token);
          localStorage.setItem('nmUser',  this._AESEncryptDecryptService.encrypt(retornoLongin.usuaNmUsuario));
          localStorage.setItem('idUser',  this._AESEncryptDecryptService.encrypt(retornoLongin.usuaIdCdUsuario));
          localStorage.setItem('reUser',  this._AESEncryptDecryptService.encrypt(retornoLongin.usuaDsRe));
          localStorage.setItem('admin',  this._AESEncryptDecryptService.encrypt(retornoLongin.usuaInAdmin));
          localStorage.setItem('empresasUsuario',  JSON.stringify(retornoLongin.operations));

          if(retornoLongin.tiusIdCdTipoUsuario == 3){
            localStorage.setItem('idEmpresaDoOperador',  this._AESEncryptDecryptService.encrypt(retornoLongin.operations[0].operIdCdOperacao));
            localStorage.setItem('idSupervisorDoOperador',  this._AESEncryptDecryptService.encrypt(retornoLongin.usuaIdCdGestor));
          }
          localStorage.setItem('idTipoUsuario',  this._AESEncryptDecryptService.encrypt(retornoLongin.tiusIdCdTipoUsuario));


          this.router.navigate(['/home']);

        }else{
          this.toastr.error(retornoLongin.msgResponse, 'ERRO AO LOGAR')
        }
      },
      error: (errorResponse) => {
        console.log(errorResponse);
        this.toastr.error(' Erro ao Logar', 'ERRO AO LOGAR')
      }
    });
  }

  validaAcessoAuthenticator(){

    this.activatedRoute.queryParams.subscribe({
      next: params => {

        if(params.token && params.usuaDsRe){

          this.configuracaoService.getConfiguracaoByChave("seguranca.acesso.authenticator").then((res:BeanConfiguracao) => {

            if(res.confDsValString.toUpperCase() != "S"){

              this.router.navigate(['']);
              this.toastr.info('Acesso via Authenticator não está permitido!', 'AUTHENTICATOR');

            }else{

              this.loginAuthenticator(params.token, params.usuaDsRe);
            }
          },
          errorResponse => {
            this.toastr.error(' Erro ao buscar Configuração de acesso via Authenticator', 'ERRO AO LOGAR')
          })
        }
      }
    });


  }

  public entrar(): void{

    localStorage.clear();

    //validar versão
    //this.configuracaoService.getConfiguracaoByChave("grupoconfig.util.versao.applicacao").then((retorno:BeanConfiguracao)=>{


      //console.log("versão apresentada: "+ this.versionApplication)
      //console.log("versão que deveria estar: "+ retorno.confDsValString)

      /*
      if(this.versionApplication != retorno.confDsValString){

        this.toastr.error("Erro versão desatualizada " , 'ERRO AO LOGAR')
        alert("*** ATENÇÃO ***\nSua versão está desatualizada, por favor:\nAbra uma janela do Google Chrome [Anonima]")
        return

      }else{
      */

      this.auth.login(this.formLogin.value.usuario, this.formLogin.value.senha ).then((retornoLongin:any)=>{

        if(retornoLongin.usuaIdCdUsuario != null && retornoLongin.usuaIdCdUsuario > 0){

          localStorage.setItem("access_token", retornoLongin.token);
          localStorage.setItem('nmUser',  this._AESEncryptDecryptService.encrypt(retornoLongin.usuaNmUsuario));
          localStorage.setItem('idUser',  this._AESEncryptDecryptService.encrypt(retornoLongin.usuaIdCdUsuario));
          localStorage.setItem('reUser',  this._AESEncryptDecryptService.encrypt(retornoLongin.usuaDsRe));
          localStorage.setItem('admin',  this._AESEncryptDecryptService.encrypt(retornoLongin.usuaInAdmin));
          localStorage.setItem('empresasUsuario',  JSON.stringify(retornoLongin.operations));

          if(retornoLongin.tiusIdCdTipoUsuario == 3){
            localStorage.setItem('idEmpresaDoOperador',  this._AESEncryptDecryptService.encrypt(retornoLongin.operations[0].operIdCdOperacao));
            localStorage.setItem('idSupervisorDoOperador',  this._AESEncryptDecryptService.encrypt(retornoLongin.usuaIdCdGestor));
          }
          localStorage.setItem('idTipoUsuario',  this._AESEncryptDecryptService.encrypt(retornoLongin.tiusIdCdTipoUsuario));


          this.router.navigate(['/home']);
        }else{
          this.toastr.error(retornoLongin.msgResponse, 'ERRO AO LOGAR')
        }

      },
      errorResponse => {
        console.log(errorResponse);
        this.toastr.error(' Erro ao Logar', 'ERRO AO LOGAR')

      })

    /*},
    errorResponse => {

      if(errorResponse.error.error == 'unauthorized'){
        this.toastr.error(' Usuário não encontrado', 'SEM ACESSO (oauth)')
      }

      if(errorResponse.error.error_description == 'Bad credentials'){
        this.toastr.error('Usuário e/ou Senha incorretos', 'SEM ACESSO (oauth)')
      }
    })*/
  }

 public exibirPainelCadastro():void{
    this.exibirPainel.emit('cadastro')
 }

  public newPass(state:string):void{

    if(state == "login"){

      this.login = true;
      this.senha = false;

    }else{

      this.login = false;
      this.senha = true;
    }
  }

  public novaSenha():void{

    localStorage.clear();

    this.auth.getUsuarioPorRe(this.formLogin.value.usuario).then((beanUsuario: BeanUsuario) => {

      if(beanUsuario != null){

        if(beanUsuario.usuaDsSenha != null){

          return this.toastr.warning(`A senha deste usuário precisa ser revogada!`,`Avise ao supervisor`);
        }

        this.auth.novaSenha(this.formLogin.value.usuario, this.formLogin.value.senha ).then((retornoLongin:any)=>{

          this.newPass("login");

          return this.toastr.success(' Senha alterada com sucesso! ', 'INFO');
        },
        errorResponse => {
          console.log(errorResponse);
          this.toastr.error(' Erro ao Alterar a senha', 'ERRO')

        })
      } else{

        this.toastr.info(`Usuário não encontrado para este (RE)`,`Avise ao supervisor`);
      }

    })
  }

}
